import firebaseApp from '../config/firebase'
import * as firebase  from 'firebase'
import 'firebase/auth'
import 'firebase/firestore'

class firebaseServicesClass {
    constructor() {
        this.auth = firebaseApp.auth();
    }
    loginWithFacebook = async () => {
        var provider = new firebase.auth.FacebookAuthProvider();
        // provider.addScope('pages_show_list');
        provider.addScope('pages_messaging');
        return await this.auth.signInWithPopup(provider)
    }
    loginWithEmail = (email, password) => this.auth.signInWithEmailAndPassword(email, password)
    signupWithEmail = async (email, password) => this.auth.createUserWithEmailAndPassword(email, password)
    signOut = () => this.auth.signOut()
    getCurrentUser = async () => await this.auth.currentUser
    checkUserAuth = user => this.auth.onAuthStateChanged(user)
    forgotPassword = (email = '') => this.auth.sendPasswordResetEmail(email)
    setFbUserIdToDb = async (profile = {}) => {
        let currentUser = await this.getCurrentUser() 
        return firebase
            .firestore()
            .collection('facebookUsers')
            .doc(currentUser.uid)
            .set(profile)
    }
}
const firebaseServices = new firebaseServicesClass()
export { firebaseServices };